<template>
    <div class="curtain-grey" @click.stop="close">
        <div class="body-card" :style="{
            'left': mouseX + 'px',
            'top': mouseY + 'px',
        }">
            <div class="item-operate" v-if="!matterItem.info.iconIsTop && !childItem.info" @click="submit(0)">
                <img class="icon-operate" src="../../../assets/images/List/OperateCard/icon-top.png" alt="">
                <div class="text-operate">置顶清单</div>
            </div>
            <div class="item-operate" v-if="matterItem.info.iconIsTop && !childItem.info" @click="submit(1)">
                <img class="icon-operate" src="../../../assets/images/List/OperateCard/icon-cancel-top.png" alt="">
                <div class="text-operate">取消置顶</div>
            </div>
            <div class="item-operate" v-if="matterItem.timeInfo.state === 2" @click="submit(2)">
                <img class="icon-operate" src="../../../assets/images/List/OperateCard/icon-clock-true.png" alt="">
                <div class="text-operate">成功打卡</div>
            </div>
            <div class="item-operate" v-if="matterItem.timeInfo.state <= 1" @click="submit(3)">
                <img class="icon-operate" src="../../../assets/images/List/OperateCard/icon-clock-false.png" alt="">
                <div class="text-operate">失败打卡</div>
            </div>
            <div class="item-operate" @click="submit(4)">
                <img class="icon-operate" src="../../../assets/images/List/OperateCard/icon-delete.png" alt="">
                <div class="text-operate">
                    <template v-if="childItem.info">删除子任务</template>
                    <template v-else>删除清单</template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "OperateCard",
    props: {
        mouseX: {
            type: Number,
            default: 0,
        },
        mouseY: {
            type: Number,
            default: 0,
        },
        matterItem: {
            type: Object,
            default: ()=>{},
        },
        childItem: {
            type: Object,
            default: ()=>{},
        },
    },
    methods: {
        close: function(){
            this.$emit("closeEvent");
        },
        submit: function(operateType){
            this.$emit("submitEvent", operateType);
        }
    },

}
</script>

<style scoped>
div.body-card{
    width: 2rem;
    height: auto;
    box-sizing: border-box;
    border: 0.02rem solid #010101;
    border-radius: 0.1rem;
    overflow: hidden;
    background: #FFFFFF;
    position: absolute;
    top: 0;
    left: 0;
}
div.item-operate{
    width: 100%;
    height: 0.44rem;
    box-sizing: border-box;
    padding: 0 0.12rem;
    display: flex;
    align-items: center;
    gap: 0.08rem;
    cursor: pointer;
}
div.item-operate:hover{
    background: rgba(255, 239, 180, 0.5);
}
img.icon-operate{
    width: 0.28rem;
    height: 0.28rem;
    display: block;
}
div.text-operate{
    flex: 1;
    font-size: 0.15rem;
    color: #000000;
    text-align: left;
}

</style>